<template>
    <div class="w-64 flex flex-col justify-start aspect-[9/12] rounded-sm shadow-center-lg">
        <div class="bg-white w-full h-3/4 flex items-center justify-center">
            <img v-if="!imgLoading" class="w-full h-full aspect-square object-cover object-center"
                :src="productImageLink" :alt="name">
            <div v-if="imgLoading">
                <svg class="animate-spin" xmlns="http://www.w3.org/2000/svg" width="3rem" height="3rem"
                    viewBox="0 0 24 24">
                    <defs>
                        <linearGradient id="mingcuteLoadingFill0" x1="50%" x2="50%" y1="5.271%" y2="91.793%">
                            <stop offset="0%" stop-color="#FFB908" />
                            <stop offset="100%" stop-color="#FFB908" stop-opacity="0.55" />
                        </linearGradient>
                        <linearGradient id="mingcuteLoadingFill1" x1="50%" x2="50%" y1="15.24%" y2="87.15%">
                            <stop offset="0%" stop-color="#FFB908" stop-opacity="0" />
                            <stop offset="100%" stop-color="#FFB908" stop-opacity="0.55" />
                        </linearGradient>
                    </defs>
                    <g fill="none">
                        <path
                            d="M24 0v24H0V0zM12.593 23.258l-.011.002l-.071.035l-.02.004l-.014-.004l-.071-.035c-.01-.004-.019-.001-.024.005l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427c-.002-.01-.009-.017-.017-.018m.265-.113l-.013.002l-.185.093l-.01.01l-.003.011l.018.43l.005.012l.008.007l.201.093c.012.004.023 0 .029-.008l.004-.014l-.034-.614c-.003-.012-.01-.02-.02-.022m-.715.002a.023.023 0 0 0-.027.006l-.006.014l-.034.614c0 .012.007.02.017.024l.015-.002l.201-.093l.01-.008l.004-.011l.017-.43l-.003-.012l-.01-.01z" />
                        <path fill="url(#mingcuteLoadingFill0)"
                            d="M8.749.021a1.5 1.5 0 0 1 .497 2.958A7.502 7.502 0 0 0 3 10.375a7.5 7.5 0 0 0 7.5 7.5v3c-5.799 0-10.5-4.7-10.5-10.5C0 5.23 3.726.865 8.749.021"
                            transform="translate(1.5 1.625)" />
                        <path fill="url(#mingcuteLoadingFill1)"
                            d="M15.392 2.673a1.5 1.5 0 0 1 2.119-.115A10.475 10.475 0 0 1 21 10.375c0 5.8-4.701 10.5-10.5 10.5v-3a7.5 7.5 0 0 0 5.007-13.084a1.5 1.5 0 0 1-.115-2.118"
                            transform="translate(1.5 1.625)" />
                    </g>
                </svg>
            </div>
        </div>

        <div class="flex w-full min-h-1/2 p-3 gap-2 items-start">
            <div class="w-1/2 text-balance font-medium">
                {{ limitCharacters(name, 20) }}
            </div>

            <div class="flex flex-col gap-2 w-1/2">
                <router-link v-bind="mode != 'default' ? { target: '_blank' } : {}"
                    :to="{ name: 'product', params: { id }, query: { categoryId } }"
                    class="hover:-translate-y-1 duration-200 border-2 border-neutral-800 rounded-md p-1 text-sm bg-transparent text-nowrap flex items-center justify-center">View
                    Product</router-link>
                <span v-if="priceRange.min != priceRange.max" class="font-semibold text-right">₱{{
                    Math.round(priceRange.min) }} - ₱{{ Math.round(priceRange.max) }}</span>
                <span v-else class="font-semibold text-right">₱{{ priceRange.min }}</span>
            </div>
        </div>
    </div>
</template>

<script setup>
const props = defineProps({
    name: {
        type: String
    },
    priceRange: {
        type: Object
    },
    id: {
        type: String
    },
    productImageLink: {
        type: String
    },
    categoryId: {
        type: String
    },
    mode: {
        type: String,
        default: 'default'
    },
    imgLoading: {
        type: Boolean
    }
})

function limitCharacters(inputString, limit) {
    if (inputString.length <= limit) {
        return inputString;
    } else {
        return inputString.substring(0, limit) + "...";
    }
}

</script>

<style>

</style>